var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFib7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m19.62,15.15c-.44-.31-1.04-.2-1.34.23-.31.44-.2,1.04.23,1.34,1.62,1.14,2.59,3.01,2.59,4.99,0,3.37-2.74,6.1-6.1,6.1s-6.1-2.74-6.1-6.1c0-1.98.97-3.85,2.59-4.99.44-.31.54-.91.23-1.34-.31-.43-.91-.54-1.34-.23-2.14,1.5-3.41,3.96-3.41,6.57,0,4.43,3.6,8.03,8.03,8.03s8.03-3.6,8.03-8.03c0-2.61-1.28-5.07-3.41-6.57Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m15,22.68c.53,0,.96-.43.96-.96v-9c0-.53-.43-.96-.96-.96s-.96.43-.96.96v9c0,.53.43.96.96.96Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m8.1.39h2.11l-3.36,9.88h-2.28L1.22.39h2.11l1.86,5.88c.1.35.21.75.32,1.21.11.46.18.78.21.96.05-.41.22-1.14.51-2.17L8.1.39Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m19.65,5.24c0,1.63-.46,2.87-1.39,3.74s-2.26,1.3-4.01,1.3h-2.8V.39h3.1c1.61,0,2.86.43,3.76,1.28s1.34,2.04,1.34,3.57Zm-2.18.05c0-2.12-.94-3.18-2.81-3.18h-1.11v6.43h.9c2.02,0,3.03-1.08,3.03-3.25Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m25.89,2c-.79,0-1.4.3-1.83.89s-.65,1.42-.65,2.48c0,2.2.83,3.3,2.48,3.3.69,0,1.53-.17,2.52-.52v1.76c-.81.34-1.72.51-2.72.51-1.44,0-2.54-.44-3.3-1.31s-1.14-2.12-1.14-3.75c0-1.03.19-1.93.56-2.7.37-.77.91-1.36,1.61-1.78s1.52-.62,2.46-.62,1.92.23,2.89.7l-.68,1.7c-.37-.18-.74-.33-1.11-.46-.37-.13-.74-.2-1.1-.2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFib7);
export default __webpack_public_path__ + "static/media/FIB7.d4223f090ce4a9a2358a67559f528243.svg";
export { ForwardRef as ReactComponent };